export default __webpack_public_path__ + "static/media/paymentTutorial_pc_middle_Cn.7976d408.webp";